import { Rule } from '../models/Product';

export const getOpenToScheduleRuleId = (): string | undefined => {
  return process.env.REACT_APP_OPEN_TO_SCHEDULE_RULEID;
};

export const getRangeDatesRuleId = (): string | undefined => {
  return process.env.REACT_APP_RANGE_DATES_RULEID;
};

export const checkGenericModalRuleId = (id: string): boolean => {
  return process.env.REACT_APP_GENERIC_MODAL_RULEID === id;
};

export const getGenericModalRule = (rules: Rule[]) => {
  return rules.find(rule => checkGenericModalRuleId(rule?.rule_id || ''));
};

export const checkGenericRulesFrontRuleId = (id: string) => {
  return process.env.REACT_APP_GENERIC_RULES_FRONT_RULEID === id;
};

export const checkGenericRulesFront = (rules: Rule[]) => {
  return rules.find(rule => checkGenericRulesFrontRuleId(rule?.rule_id || ''));
};

export const checkServiceOptionsTitleRuleId = (id: string) => {
  return process.env.REACT_APP_SERVICE_OPTIONS_TITLE_RULEID === id;
};

export const getServiceOptionsTitle = (rules: Rule[]) => {
  return rules.find(rule => checkServiceOptionsTitleRuleId(rule?.rule_id || ''))?.value;
};

export const appointmentForSameDayRule = (id: string) => {
  return process.env.REACT_APP_SCHEDULE_SAME_DAY_RULEID === id;
};
